import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPushpin = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.826 4.479v.825c0 .597.358 1.134.908 1.365l.034.014c.55.23.908.768.908 1.364V9.91c0 .239-.058.474-.168.685L6.994 13.49a1.48 1.48 0 0 0 1.311 2.164h7.39a1.48 1.48 0 0 0 1.311-2.164l-1.514-2.895a1.5 1.5 0 0 1-.169-.685V8.047c0-.596.36-1.134.91-1.364l.033-.014a1.48 1.48 0 0 0 .908-1.365v-.825c0-.817-.662-1.479-1.479-1.479h-7.39c-.817 0-1.479.662-1.479 1.479"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 15.656v5.346"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPushpin);
export default ForwardRef;
